import { GlobovmsLogo } from "../brand/GlobovmsLogo";

export function KioskPanel({ compact = false }) {
  return (
    <div className={`rounded-[28px] bg-[#121820] shadow-2xl ${compact ? "w-[168px] p-2" : "w-[280px] p-3 sm:w-[320px]"}`}>
      <div className="rounded-xl bg-white px-5 pb-4 pt-5">
        <GlobovmsLogo compact={compact} />
        <p className={`${compact ? "mt-4 text-lg" : "mt-10 text-3xl"} font-bold`}>Welcome</p>
        <p className="mt-1 text-xs text-slate-500">Please select an option</p>
        <div className={`${compact ? "mt-4" : "mt-8"} grid gap-2`}>
          <div className="rounded bg-brand-orange px-3 py-3 text-center text-sm font-semibold text-white">Check In →</div>
          <div className="rounded border border-slate-200 px-3 py-3 text-center text-sm font-semibold">Scan QR Code</div>
          <div className="rounded border border-slate-200 px-3 py-3 text-center text-sm font-semibold">Check Out</div>
        </div>
        {compact ? null : (
          <div className="mt-8 flex justify-between text-xs font-semibold text-slate-500">
            <span>Language</span>
            <span>Help</span>
          </div>
        )}
      </div>
    </div>
  );
}
